<p-dialog
  [visible]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '560px' }"
  [header]="title"
  (onHide)="onCancel()"
>
  <div class="mb-3 p-3 border-round surface-100">
    <p class="m-0 text-sm">{{ message }}</p>
  </div>

  <form [formGroup]="reasonForm">
    <label class="block text-sm font-medium mb-2" for="fefoOverrideReason">
      {{ 'stock.fefo.reason' | translate }}
      <span class="text-red-500">*</span>
    </label>
    <textarea
      id="fefoOverrideReason"
      pTextarea
      formControlName="reason"
      [rows]="4"
      class="w-full"
      [placeholder]="'stock.fefo.override_placeholder' | translate"
    ></textarea>
    @if (reasonForm.get('reason')?.invalid && reasonForm.get('reason')?.touched) {
      <small class="text-red-500 block mt-1">
        {{ 'outbound_management.messages.fefo_override_required' | translate }}
      </small>
    }
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <app-button
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
      ></app-button>
      <app-button
        [label]="'common.actions.confirm' | translate"
        type="info"
        [disabled]="reasonForm.invalid"
        (emitOnClick)="onConfirm()"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>
